<div mat-dialog-title>

  <div class="mat-dialog-title-wrapper">
    <span class="mat-dialog-title-text">{{title || 'Values'}}</span>
  </div>
  <button class="iconButton iconButton--transparent" id="closeButtonTopicsDialog" (click)="cancel()">
    <img src="assets/images/icons/blue/close.png" alt="close" class="iconButton__icon ico--sm " />
  </button>
</div>
<div mat-dialog-content>
  <div class="spinner-container" *ngIf="!showValues">
    <mat-spinner #spinner></mat-spinner>
  </div>
  <div class="container" *ngIf="showValues">
    <div class="container__row mb-3">
      <div class="container__column">
        <p class="fontWeight--bold">{{description || 'Select Value'}}</p>
      </div>
    </div>
    <div class="treeBorderBox">
      <app-attribute-values-tree-container *ngIf="showValues!=null" [attributeValuesTree]="showValues"
        (selectedElementChanged)="selectedElementChanged($event)" (confirmSelection)="confirmSelection()">
      </app-attribute-values-tree-container>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button type="button" class="button button--secondary  button--cancel" id="closeButtonTemplateTitleDialog"
    (click)="cancel()">Cancel</button>
  <button type="button" class="button button--primary  button--save" id="saveButtonTemplateTitleDialog"
    (click)="save()">Save</button>
</div>
